import ScanpixApi from "./index";

export default class LightboxOpenAction extends ScanpixApi {
  constructor() {
    super();
    super._setAction("lightboxopen.action");
  }

  async fetchLightboxById(lightboxId) {
    super._setQuery({ fetchLightboxById: "", lightboxId });
    return super._fetch();
  }

  async getCurrentLightbox(lightboxId) {
    super._setQuery({ list: "", lightboxId });
    return this._fetch();
  }
}
